import config from 'src/config/config';
import api from 'src/api/interceptor';

export function getProductListApi(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  selectedFilterOption,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  queryString,
) {
  const tableFieldFilterList = tableFieldFilter
    .map((id) => `field_id=${id}`)
    .join('&');
  const searchFieldFilterList = new URLSearchParams(queryString).toString();
  return api
    .get(
      `${config.test_url}api/material/get-product-list/?${tableFieldFilterList}&${searchFieldFilterList}`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          page_number: pageNumber,
          search_query: searchInput,
          recent_filter_choice: selectedFilterOption,
          sort_order: tableSortOrder,
          sort_field: tableSortField,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}
